import { FC, ReactNode } from "react";
import NumberControl, { NumberControlType } from "src/components/NumberControl/NumberControl";
import cn from "classnames";

type InputChipProps = Partial<{
  label: ReactNode;
  subLabel: ReactNode;
  classNames:Partial<{
    label:string;
    subLabel:string;
    numberControl:string;
    textContainer:string;
  }>
  disabled:boolean;
}>;


const InputChip: FC<InputChipProps & NumberControlType> = ({ label, subLabel,classNames,disabled,className, ...props }) => {
  return (
    <div className={cn("flex w-full items-center justify-between gap-4",className)}>
      <div className={cn("flex-2 flex flex-col items-start justify-center",classNames?.textContainer)}>
        <span className={classNames?.label}>{label}</span>
        <span className={classNames?.subLabel}>{subLabel}</span>
      </div>
      <div className="flex-1">
        <NumberControl disabled={disabled} className={classNames?.numberControl} {...props} classNames={{
          actions:classNames?.actions,
          display:classNames?.display
        }}/>
      </div>
    </div>
  );
};

export default InputChip;
export type {InputChipProps};